import { BankAccount } from 'components/OnlineFormData/components/BankAccountsList';
import { Property } from 'components/OnlineFormData/components/PropertiesList';
import { Chattel } from 'components/OnlineFormData/components/ChattelsList';
import { Expense } from 'components/OnlineFormData/components/ExpensesList';

export const prepareCacheData = (data: any) => {
  const output = {
    // TODO: přejmenovat na step, přesná identifikace, ve kterém kroku formulář je
    status: data?.status || undefined,
    // TODO: na co to je? nikde se s tím nepracuje
    started: data?.started || undefined,
    clientLogged: data?.clientLogged || undefined,
    clientLoggedBefore: data?.clientLoggedBefore || undefined,
    firstName: data?.firstName || undefined,
    lastName: data?.lastName || undefined,
    mobil: data?.mobil || undefined,
    email: data?.email || undefined,
    cislo_op: data?.cislo_op || undefined,
    rc: data?.rc || undefined,
    street: data?.street || undefined,
    houseNumber: data?.houseNumber || undefined,
    city: data?.city || undefined,
    zipCode: data?.zipCode || undefined,
    mailingAddress: data?.mailingAddress || undefined,
    mailingAddressStreet: data?.mailingAddressStreet || undefined,
    mailingAddressHouseNumber: data?.mailingAddressHouseNumber || undefined,
    mailingAddressCity: data?.mailingAddressCity || undefined,
    mailingAddressZipCode: data?.mailingAddressZipCode || undefined,
    maritalStatus: data?.maritalStatus || undefined,
    children: data?.children || undefined,
    living: data?.living || undefined,
    income: data?.income || undefined,
    incomeValue: data?.incomeValue || undefined,
    // druhý klient
    client2: data?.client2 || undefined,
    // zvolený produkt
    productId: data?.productId || undefined,
    doublePayments: data?.doublePayments || false,
    installments: data?.installments || false,
    installmentsData: data?.installmentsData || null,
    installmentsPlan: data?.installmentsPlan || null,
    payment: !isNaN(data?.payment) ? data?.payment : null,
    paymentDate: data?.paymentDate || undefined,
    paymentMethod: data?.paymentMethod || undefined,
    secondPayment: !isNaN(data?.secondPayment) ? data?.secondPayment : null,
    secondPaymentDate: data?.secondPaymentDate || undefined,
    debts: data?.debts
      ? data?.debts?.map((d: any) => {
          return {
            jmeno: d.jmeno,
            stav_dluhu: parseInt(d.stav_dluhu?.toString() || '0'),
            debtStatus: {
              kod: d?.debtStatus?.kod || '',
              popis: d?.debtStatus?.popis || '',
            },
            druh_smlouvy_veritele: d.druh_smlouvy_veritele,
            vyse_pujcky: d.vyse_pujcky,
            zbyva_uhradit: d.zbyva_uhradit,
          };
        })
      : undefined,
    expensesList: data?.expensesList
      ? data?.expensesList?.map((e: Expense) => {
          return {
            popis: e.popis,
            cena: e.cena,
          };
        })
      : undefined,
    execution: data?.execution || undefined,
    deductionsFromWages: data?.deductionsFromWages || undefined,
    bankAccounts: data?.bankAccounts || undefined,
    bankAccountsList: data?.bankAccountsList?.map((b: BankAccount) => {
      return {
        bankName: b.bankName,
        balance: b.balance,
      };
    }),
    blockedBankAccounts: data?.blockedBankAccounts || undefined,
    properties: data?.properties || undefined,
    propertiesList: data?.propertiesList?.map((d: Property) => {
      return {
        cena: d.cena,
        druh: d.druh,
        popis: d.popis,
      };
    }),
    chattels: data?.chattels || undefined,
    chattelsList: data?.chattelsList?.map((c: Chattel) => {
      return {
        cena: c.cena,
        druh: c.druh,
        popis: c.popis,
      };
    }),
    questions: data?.questions || undefined,
    questionResults: data?.questionResults || undefined,
    // TODO: na co to je? nikde se s tím aktivně nepracuje
    presentationDone: data?.presentationDone || undefined,
    // TODO: jsou ty souhlasy tady potřeba???
    agreeVop: data?.agreeVop || undefined,
    agreePovinostPlatby: data?.agreePovinostPlatby || undefined,
    agreeZacatekPoskytovaniSluzeb: data?.agreeZacatekPoskytovaniSluzeb || undefined,
    agreeReklamacniPoriadok: data?.agreeReklamacniPoriadok || undefined,
    agreeVzorovyFormularOdstoupeni: data?.agreeVzorovyFormularOdstoupeni || undefined,
    lastUpdate: data?.lastUpdate || undefined,
    // TODO: na co to je?
    transmitReportDone: data?.transmitReportDone || undefined,
  };

  if (output.questions) {
    delete output.questions.__typename;
  }
  if (output.questionResults) {
    delete output.questionResults.__typename;
  }

  return output;
};
